import React, { useRef, useEffect } from 'react';
import { Element } from 'react-scroll';
import { FaDownload } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2; // Set your desired speed here
    }
  }, []);

  const handleDownloadResume = () => {
    const resumeUrl = 'https://drive.google.com/file/d/1E1VLtCSxPTdIftJMv9-AxpcCZ5P9M9YT/view?usp=sharing';
    window.open(resumeUrl, '_blank');
  };
//change
  return (
    <Element name="home">
      <section className="hero">
        {/* Video Background */}
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className="hero-video"
        >
          <source src="newHero.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Hero Content */}
        <div className="hero-container">
          <div className="hero-image">
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/e/e4/NSUT_logo.png?20200705214344" 
              alt="Profile" 
              className="profile-image"
            />
          </div>
          <div className="hero-content">
            <h1>NIKHIL NEGI</h1>
            <div className="hero-description">
              <ul>
                <li><strong>B.Tech in Electronics and Communication Engineering with a specialization in Artificial Intelligence and Machine Learning at NSUT, Delhi.</strong></li>
                <li><strong>Passionate about:</strong>
                  <ul>
                    <li><strong>Coding</strong></li>
                    <li><strong>Technology innovation</strong></li>
                    <li><strong>Building solutions that make a difference</strong></li>
                  </ul>
                </li>
                <li><strong>Currently exploring the exciting world of AI/ML.</strong></li>
                <li><strong>Focused on developing strong programming fundamentals.</strong></li>
              </ul>
            </div>
            <button 
              className="download-resume-btn" 
              onClick={handleDownloadResume}
            >
              <FaDownload /> Download Resume
            </button>
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Hero;
